// Safari (iOS/iPadOS/macOS < 26.4) doesn't support async iteration of ReadableStream,
// which pdfjs relies on (e.g. `for await (const value of readableStream)` in getTextContent).
if (typeof ReadableStream.prototype[Symbol.asyncIterator] !== "function") {
  async function* values<T>(
    this: ReadableStream<T>,
    { preventCancel = false }: ReadableStreamIteratorOptions = {},
  ) {
    const reader = this.getReader();
    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) return;
        yield value;
      }
    } finally {
      // Cancels only on early exit; it's a no-op on an already-closed stream.
      if (!preventCancel) await reader.cancel().catch(() => {});
      reader.releaseLock();
    }
  }

  for (const key of ["values", Symbol.asyncIterator]) {
    Object.defineProperty(ReadableStream.prototype, key, {
      configurable: true,
      value: values,
      writable: true,
    });
  }
}

export {};
